import * as React from 'react';
import { ChevronDown, ChevronUp } from 'react-feather';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import * as EditorActions from '../../../actions/editor';
import { NAVBAR } from '../../../constants/consts';
class DebugPaneHeader extends React.PureComponent {
    componentDidMount() {
        if (this.props.logs || this.props.navItem === NAVBAR.Logs) {
            this.props.showLogs(true);
        }
    }
    render() {
        const { toggleDebugPane, debugPane, showLogs, error, logs, navItem, toggleNavbar, warns, errors } = this.props;
        return (React.createElement("div", { className: "pane-header", onClick: toggleDebugPane },
            React.createElement("ul", { className: "tabs-nav" },
                React.createElement("li", { className: error || (logs && navItem === NAVBAR.Logs) ? 'active-tab' : undefined, onClick: (e) => {
                        if (debugPane) {
                            e.stopPropagation();
                        }
                        showLogs(true);
                        toggleNavbar(NAVBAR.Logs);
                    } },
                    React.createElement("span", { className: "logs-text" }, "Logs"),
                    error ? (React.createElement("span", { className: "error" }, "(Error)")) : errors.length > 0 ? (React.createElement("span", { className: "error" },
                        "(",
                        errors.length,
                        ")")) : warns.length > 0 ? (React.createElement("span", { className: "warnings-count" },
                        "(",
                        warns.length,
                        ")")) : ('')),
                error === null && (React.createElement("li", { className: navItem === NAVBAR.DataViewer ? 'active-tab' : undefined, onClick: (e) => {
                        if (debugPane) {
                            e.stopPropagation();
                        }
                        showLogs(false);
                        toggleNavbar(NAVBAR.DataViewer);
                    } }, "Data Viewer")),
                error === null && (React.createElement("li", { className: navItem === NAVBAR.SignalViewer ? 'active-tab' : undefined, onClick: (e) => {
                        if (debugPane) {
                            e.stopPropagation();
                        }
                        showLogs(false);
                        toggleNavbar(NAVBAR.SignalViewer);
                    } }, "Signal Viewer")),
                error === null && (React.createElement("li", { className: navItem === NAVBAR.DataflowViewer ? 'active-tab' : undefined, onClick: (e) => {
                        if (debugPane) {
                            e.stopPropagation();
                        }
                        showLogs(false);
                        toggleNavbar(NAVBAR.DataflowViewer);
                    } }, "Dataflow Viewer"))),
            debugPane ? React.createElement(ChevronDown, null) : React.createElement(ChevronUp, null)));
    }
}
function mapStateToProps(state, ownProps) {
    return {
        debugPane: state.debugPane,
        error: state.error,
        errors: state.errors,
        logs: state.logs,
        navItem: state.navItem,
        warns: state.warns,
    };
}
export function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        showLogs: EditorActions.showLogs,
        toggleDebugPane: EditorActions.toggleDebugPane,
        toggleNavbar: EditorActions.toggleNavbar,
    }, dispatch);
}
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(DebugPaneHeader));
